import { abyssColors } from '@/theme/colors';
import { styled as muiStyled } from '@mui/material/styles';
import { Box, Paper, Stack, Select } from '@mui/material';

export const InputBox = muiStyled(Box)({
  flex: 1,
});

export const FieldRow = muiStyled(Stack)({
  flexDirection: 'row',
  gap: '2.4rem',
  borderRadius: '0.8rem',
  border: `0.1rem solid ${abyssColors.primary[200]}`,
  padding: '1.6rem',
  backgroundColor: abyssColors.neutral[50],
});

export const ColumnBox = muiStyled(Box)({
  padding: '0.8rem',
  backgroundColor: 'white',
  borderRadius: '0.4rem',
  border: '0.1rem solid',
  borderColor: abyssColors.primary[200],
});

export const MappedColumnPaper = muiStyled(Paper)({
  padding: '2.4rem',
  width: '100%',
  maxWidth: '94.8rem',
  backgroundColor: abyssColors.primary[50],
  borderRadius: '0.8rem',
});

export const StyledSelect = muiStyled(Select)({
  fontSize: '1.2rem',
  border: `0.1rem solid ${abyssColors.primary[200]}`,
  '& .MuiOutlinedInput-input': {
    padding: '0.8rem',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiSelect-icon': {
    fontSize: '1.6rem',
    color: abyssColors.primary[500],
  },
});
